import Pedidos from './pedidos.vue';
import PedidoForm from './pedido-form.vue';
import RoutesUtils from './../../js/RoutesUtils.js';

var routes = [{
        path: '/pedidos/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('pedidos', ['ADMIN'], Pedidos),
        //keepAlive: true
    },
    {
        path: '/pedidos/new/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('pedidos/new', ['ADMIN'], PedidoForm)
    },
    {
        path: '/pedidos/edit/:id/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('pedidos/edit', ['ADMIN'], PedidoForm)
    },
    {
        path: '/pedidos/view/:id/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('pedidos/view', ['ADMIN'], PedidoForm, { editable: false })
    },
];
export default routes;